export const alloysPartnersShopifyFetchProductTags = "/alloys/partners/shopify/:integration_id/fetch_product_tags";
